import { AppConfig } from "~/types";

export const appConfig: AppConfig = {
  appTitle: "Ikon",
  preview: `${process.env.NEXT_PUBLIC_PREVIEW_LOCKED}` === "1",
  postsPerPage: 24,
  defaultApiCacheTimeMinutes: parseInt(`${process.env.NEXT_PUBLIC_DEFAULT_API_CACHE_TIME ?? 5}`),
  previewPwd: `${process.env.NEXT_PUBLIC_PREVIEW_PWD}`,
  baseUrl: process.env.NODE_ENV === "development" ? '' : `${process.env.NEXT_PUBLIC_URL ?? ""}`,
  cmsUrl: `${process.env.NEXT_PUBLIC_CMS_BASE_URL ?? ""}`,
  apiUrl: `${process.env.NEXT_PUBLIC_CMS_BASE_URL ?? ""}/wp-json`,
  searchUrl: `${process.env.NEXT_PUBLIC_API_URL ?? ""}`,
  newsletterSecret: `${process.env.NEXT_PUBLIC_NEWSLETTER_SECRET ?? ""}`,
  twitterHandle: "ikongallery",
  gaProperty: `${process.env.NEXT_PUBLIC_GA_PROPERTY ?? ""}`,
  goldenRatioBase: {
    base: 500,
    mobile: 600,
    tablet: 887,
    desktop: 987,
    screen: 1287,
  },
  // xxx TODO set dynamic interval ...
  revalidateInterval: (scope: string, data: any) => {
    return 30;
  }
};
